import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#050505] app-public-shell">
      <Header />
      <Outlet />
      <WhatsAppButton />
    </div>
  );
}
